var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSleepIconinline = function SvgSleepIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "ba"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75B2F0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B275F0",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.5 -.967)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#ba)",
    cx: 32.5,
    cy: 32.967,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.552 45.311c-5.082 0-9.703-3.194-11.5-7.948a.607.607 0 01.763-.79c1.155.395 2.359.594 3.576.594 6.11 0 11.08-4.97 11.08-11.079 0-1.344-.241-2.661-.715-3.914a.607.607 0 01.763-.789 12.29 12.29 0 018.325 11.634c0 6.778-5.514 12.292-12.292 12.292",
    fill: "#FFF"
  }))));
};
export default SvgSleepIconinline;